import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Candidature} from '../candidature.model';
import {CALENDAR_FR} from '../../../shared/calendar/calendar.constants';
import {Commune, Departement, GrhumService, Pays} from '../../grhum';
import {Response} from '@angular/http';
// noinspection TypeScriptPreferShortImport
import {Adresse} from '../adresse/adresse.model';
import {CandidatureFormation} from '../candidature-formation.model';
// noinspection TypeScriptPreferShortImport
import {AdresseService} from '../adresse/adresse.service';

@Component({
    selector: 'jhi-civilite-component',
    templateUrl: './civilite.component.html'
})
export class CiviliteComponent implements OnInit {

    @Input() candidature: Candidature;
    @Input() candidatureFormation: CandidatureFormation;
    @Input() adresse: Adresse;
    @Output() adresseChange: EventEmitter<Adresse> = new EventEmitter();
    @Input() paysListe: Pays[];
    @Input() deptListe: Departement[];
    @Input() isEditable: Boolean;
    villesAdresse: Commune[];
    fr: any;

    constructor(public grhumService: GrhumService,
                private adresseService: AdresseService) {
    }

    ngOnInit() {
        this.fr = CALENDAR_FR;
        if (!this.adresse || this.adresse.candidatureId == null) {
            this.adresse = new Adresse();
            // Préremplir l'adresse avec la dernière candidature créée, si existe
            this.adresseService.query({ userId: this.candidatureFormation.userId }).subscribe(
                (res: Response) => {
                    let adresses = res.json();
                    if (adresses != null && adresses.length > 0) {
                        this.adresse = adresses[0];
                    }
                    this.adresse.id = null;
                    this.adresse.candidatureId = this.candidature.id;
                    this.adresseChange.emit(this.adresse);
                },
                (res: Response) => {
                    this.adresse.candidatureId = this.candidature.id;
                    this.adresseChange.emit(this.adresse);
            });
        }
        if (this.candidatureFormation.reinscription) {
            this.isEditable = false;
        }
    }

    onChangeCodePostal() {
        if (this.adresse.codePostal && this.adresse.codePostal !== '') {
            this.grhumService.queryCommune({codePostal: this.adresse.codePostal}).subscribe(
                (res: Response) => {
                    this.villesAdresse = res.json();
                    this.adresse.ville = null;
                });
        } else {
            this.villesAdresse = [];
        }
        this.adresseChange.emit(this.adresse);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/candidature/civilite/civilite.component.ts